import { useState, useEffect, useRef } from 'react'

import { FOOD_FIGHT_DURATION } from '../../constants'

const useTriggerAnimation = () => {
    const isMountRef = useRef(false)
    const [animate, setTriggerAnimation] = useState(false)

    useEffect(() => {
        isMountRef.current = true
        const setAnimation = setTimeout(() => {
            if (isMountRef.current) {
                setTriggerAnimation(() => true)
            }
        }, FOOD_FIGHT_DURATION)

        return () => {
            isMountRef.current = false
            clearTimeout(setAnimation)
        }
    }, [])

    return animate
}

export default useTriggerAnimation
